import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();

  // URL for the Map Link
  const googleMapsUrl = "https://maps.google.com/?q=42,+Kaluramji+Ki+Bari,+Gayriyawas,+Udaipur,+Rajasthan+313002";

  // Products locale se aayenge — fully translated
  const footerProducts = t("footerProducts.items", { returnObjects: true });

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Brand Section */}
        <div className="footer-brand">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
            <img 
              src="/images/logo.png" 
              alt="Chirayu Medicos Logo" 
              style={{ width: '50px', height: '50px', borderRadius: '5px', objectFit: 'cover' }} 
            />
            <h3 className="footer-logo" style={{ margin: 0 }}>
              {t("logo.main")} <span>{t("logo.sub")}</span>
            </h3>
          </div>
          <p>{t("footer.description")}</p>
          <div className="footer-socials">
            <a href="#" aria-label="Facebook">f</a>
            <a href="#" aria-label="Instagram">in</a>
            <a href="#" aria-label="Twitter">tw</a>
            <a href="#" aria-label="Youtube">yt</a>
          </div>
        </div>

        {/* Quick Links Section */}
        <div className="footer-section">
          <h4>{t("footer.quickLinks")}</h4>
          <ul>
            <li><Link to="/">{t("nav.home")}</Link></li>
            
            {/* UPDATED: Appended the inline subtitle reference to match image_50217c.png */}
            <li>
              <Link to="/about">
                {t("nav.about")} <span style={{ fontSize: '12px', opacity: 0.75, fontWeight: 'normal', marginLeft: '4px' }}>(Terms & Policies)</span>
              </Link>
            </li>
            
            <li><Link to="/products">{t("nav.products")}</Link></li>
            <li><Link to="/testimonials">{t("nav.testimonials")}</Link></li>
            <li><Link to="/faq">{t("nav.faq")}</Link></li>
            <li><Link to="/contact">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        {/* Our Products Section - Fully Translated */}
        <div className="footer-section">
          <h4>{t("footerProducts.ourProductsTitle")}</h4>
          <ul style={{ maxHeight: '180px', overflowY: 'auto', paddingRight: '5px', scrollbarWidth: 'none' }}>
            {Array.isArray(footerProducts) && footerProducts.map((product, index) => (
              <li key={index}>
                <a href={`/products#product-${product.id}`} style={{ fontSize: '13px', textDecoration: 'none' }}>
                  {product.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Us Section - Split lines, Address added, Increased Gap */}
        <div className="footer-section">
          <h4>{t("footer.contactUs")}</h4>
          <ul className="contact-list" style={{ listStyle: 'none', padding: 0 }}>
            
            {/* Phone numbers */}
            <li style={{ marginBottom: '18px', display: 'flex', alignItems: 'flex-start' }}>
              <span className="contact-icon" style={{ marginRight: '12px', marginTop: '2px' }}>📞</span>
              <div style={{ fontSize: '14px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <a href="tel:9166446452" style={{ textDecoration: 'none' }}>+91 9166446452</a>
                <a href="tel:9928212439" style={{ textDecoration: 'none' }}>+91 9928212439</a>
              </div>
            </li>

            {/* Email addresses */}
            <li style={{ marginBottom: '18px', display: 'flex', alignItems: 'flex-start' }}>
              <span className="contact-icon" style={{ marginRight: '12px', marginTop: '2px' }}>✉️</span>
              <div style={{ fontSize: '13.5px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <a href="mailto:admin@chirayumedicos.com" style={{ textDecoration: 'none' }}>admin@chirayumedicos.com</a>
                <a href="mailto:sales@chirayumedicos.com" style={{ textDecoration: 'none' }}>sales@chirayumedicos.com</a>
              </div>
            </li>

            {/* Address */}
            <li style={{ display: 'flex', alignItems: 'flex-start' }}>
              <span className="contact-icon" style={{ marginRight: '12px', marginTop: '2px' }}>📍</span>
              <div style={{ fontSize: '13.5px', lineHeight: '1.6' }}>
                <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                  {t("footer.address")}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t("footer.copyright")}</p>
        <p className="footer-made">{t("footer.tagline")}</p>
      </div>
    </footer>
  );
}

export default Footer;